// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__a7HHj","tabs":"Tabs_tabs__TkNzQ","tab":"Tabs_tab__MOgux","selected":"Tabs_selected____vft","component":"Tabs_component__mSkuz"};